import { useEffect, useState } from "react";
import { getUserFullProfile } from "sr/utils/api/user/user";

import { OnboardingChecklist } from "app/pages/company/work-order/contractor/components/OnboardingChecklist";

function Step4(props: any) {
  const [requiredChecklist, setRequiredChecklist] = useState<any[]>([]);

  useEffect(() => {
    const loadProfile = async () => {
      const response = await getUserFullProfile();
      setRequiredChecklist(response?.data?.user_type_detail?.requiredOnBordingChecklist || []);
    };
    loadProfile();
  }, []);

  return (
    <OnboardingChecklist
      contractorId={props?.data?.id}
      requiredChecklist={requiredChecklist}
      value={props?.data?.onBoardingChecklistCheck}
      onBoardingStatus="pending"
      onSaved={(checks, status) =>
        props?.onChange({
          ...props?.data,
          onBoardingChecklistCheck: checks,
          onBoardingStatus: status,
        })
      }
      onBack={() => props?.onBack()}
      finishLabel="Next"
    />
  );
}

export default Step4;
